import $ from 'jquery';
const ELEMENT_SELECTOR = '.js__age-verification-citadele-form';
export class AgeVerificationCitadele {
    static $element;
    static init() {
        this.$element = $(ELEMENT_SELECTOR);
        if (this.$element.length) {
            this.$element.trigger('submit');
        }
    }
}
